import { useTranslation } from 'react-i18next';
import { getCloudinaryUrl } from '../../utils/cloudinaryImage';
import { formatRelativeDate } from '../../utils/formatDate';
import { getNotificationContent, getNotificationLink } from '../../utils/notificationMeta';
import BellIcon from '../../assets/icons/BellIcon';
import './NotificationItem.css';

const DEFAULT_AVATAR = 'https://res.cloudinary.com/dhzvdfpop/image/upload/v1776983361/default-avatar_q5zqfy.jpg';

const NotificationItem = ({ notification, onOpen }) => {
    const { t, i18n } = useTranslation();
    const { text, secondary } = getNotificationContent(notification, t, i18n.language);
    const { actor, isRead, updatedAt } = notification;
    const clickable = Boolean(getNotificationLink(notification)) || !isRead;

    return (
        <button
            type="button"
            data-testid="notification-item"
            data-type={notification.type}
            className={`notification-item${isRead ? '' : ' notification-item--unread'}${clickable ? '' : ' notification-item--static'}`}
            onClick={() => onOpen(notification)}
        >
            {actor ? (
                <img
                    src={getCloudinaryUrl(actor.avatar || DEFAULT_AVATAR, { width: 80, height: 80 })}
                    onError={(e) => { e.target.src = DEFAULT_AVATAR; }}
                    alt=""
                    className="notification-item__avatar"
                    loading="lazy"
                />
            ) : (
                <span className="notification-item__avatar notification-item__avatar--system">
                    <BellIcon size={18} />
                </span>
            )}

            <span className="notification-item__body">
                <span className="notification-item__text">{text}</span>
                {secondary && (
                    <span className={`notification-item__secondary${notification.type === 'System' ? ' notification-item__secondary--wrap' : ''}`}>
                        {secondary}
                    </span>
                )}
                <span className="notification-item__time">{formatRelativeDate(updatedAt, i18n.language)}</span>
            </span>

            {!isRead && <span className="notification-item__dot" />}
        </button>
    );
};

export default NotificationItem;
